import React, { useEffect, useState } from "react";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

function token() {
  try {
    return localStorage.getItem("token") || localStorage.getItem("giraia_curso_token") || "";
  } catch (e) {
    return "";
  }
}

function zap(numero, nome, concluiu) {
  let n = String(numero || "").replace(/\D/g, "");
  if (!n) return null;
  if (n.length <= 11) n = "55" + n;
  const primeiro = String(nome || "").split(" ")[0];
  const msg = concluiu
    ? "Oi, " + primeiro + "! Aqui é da Giraia Bike Shop. Parabéns pelo certificado da aula grátis! Os módulos estão com preço de lançamento até 30/11. Quer que eu te explique?"
    : "Oi, " + primeiro + "! Aqui é da Giraia Bike Shop. Vi que você começou a aula grátis do curso de segurança. Conseguiu terminar? Ficou alguma dúvida?";
  return "https://wa.me/" + n + "?text=" + encodeURIComponent(msg);
}

function Card({ titulo, valor, sub }) {
  return (
    <div className="p-4 rounded-xl border border-[#E2B84A]/40 bg-white/5">
      <div className="text-sm text-gray-300">{titulo}</div>
      <div className="text-3xl font-bold text-[#E2B84A] mt-1" style={{ fontFamily: "Outfit" }}>{valor}</div>
      {sub && <div className="text-xs text-gray-400 mt-1">{sub}</div>}
    </div>
  );
}

export default function AdminMetricasPage() {
  const [d, setD] = useState(null);
  const [erro, setErro] = useState("");

  useEffect(() => {
    fetch(API + "/admin/metricas-curso", { headers: { Authorization: "Bearer " + token() } })
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then(setD)
      .catch((e) => setErro("Não foi possível carregar (" + e + "). Entre de novo com sua conta."));
  }, []);

  const pct = (a, b) => (b ? Math.round((a / b) * 100) + "%" : "0%");

  return (
    <div className="min-h-screen bg-[#141118] text-[#F2F0EA] px-4 py-8" style={{ fontFamily: "Manrope" }}>
      <div className="max-w-2xl mx-auto">
        <a href="/admin/painel" className="text-sm text-[#E2B84A]">← Painel da Loja</a>
        <h1 className="text-2xl font-bold text-[#E2B84A] mt-3" style={{ fontFamily: "Outfit" }}>Resultados do curso</h1>
        <p className="text-sm text-gray-400 mb-5">Seus testes e os do Valdecir não entram na conta.</p>

        {erro && <p className="text-red-300">{erro}</p>}
        {!d && !erro && <p className="text-gray-400">Carregando...</p>}

        {d && (
          <>
            <div className="grid grid-cols-2 gap-3">
              <Card titulo="Começaram a aula grátis" valor={d.comecaram} sub={d.comecaram_7d + " nos últimos 7 dias"} />
              <Card titulo="Terminaram (certificado)" valor={d.terminaram} sub={pct(d.terminaram, d.comecaram) + " de quem começou"} />
              <Card titulo="Compraram" valor={d.compras_pagas} sub={d.compras_pendentes + " PIX aguardando conferência"} />
              <Card titulo="Vendido no curso" valor={"R$ " + d.vendido.toFixed(2).replace(".", ",")} sub={d.por_indicacao + " vieram por indicação"} />
            </div>

            <h2 className="text-lg font-semibold mt-8 mb-3">Quem começou</h2>
            {d.lista.length === 0 && <p className="text-gray-400">Ninguém ainda.</p>}
            <div className="grid gap-2">
              {d.lista.map((x, i) => {
                const link = zap(x.whatsapp, x.nome, x.concluiu);
                return (
                  <div key={i} className="flex items-center justify-between gap-3 p-3 rounded-xl bg-white/5">
                    <div>
                      <div className="font-semibold">{x.nome}</div>
                      <div className="text-xs text-gray-400">
                        {x.criado_em.split("-").reverse().join("/")} · {x.concluiu ? "✅ terminou" + (x.nota != null ? " (nota " + x.nota + ")" : "") : "⏳ não terminou"}
                      </div>
                    </div>
                    {link && (
                      <a href={link} target="_blank" rel="noopener noreferrer" className="shrink-0 px-3 py-2 rounded-lg bg-[#E2B84A] text-[#141118] text-sm font-semibold">
                        WhatsApp
                      </a>
                    )}
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
